/**
 * 极简 Loading
 */
export function LoadingSpinner({ size = 24 }: { size?: number }) {
  return (
    <div
      className="inline-block animate-spin rounded-full"
      style={{
        width: size,
        height: size,
        border: '2.5px solid rgba(168,196,160,0.3)',
        borderTopColor: '#6B9E6B',
      }}
    />
  );
}

export function LoadingPage({ label = '加载中...' }: { label?: string }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" style={{ color: '#6B9E6B' }}>
      <LoadingSpinner size={32} />
      <span className="text-sm" style={{ fontFamily: '"Noto Serif SC", serif' }}>{label}</span>
    </div>
  );
}
